module.exports = __webpack_public_path__ + "img/220.854dff83.jpg";